import {
    setSelectedProductUpdate
} from "src/actions/QueryProductUpdateAction";
import { call, put, takeLatest } from "redux-saga/effects";

import {
    getAdditionalInfoQuerySuccessAction,
    getSelectedProductQueryFailedAction, getSelectedProductQuerySuccessAction,
    SELECTED_PRODUCT_QUERY_START, SelectedProductQueryStartAction
} from "src/actions/SelectedProductQueryAction";
import {SelectedProductResponse} from "src/model/ProductMatch";
import QueryProductInfo from "src/model/QueryProduct";
import { getCurrencyUnitConfig } from "src/config/Config";
import ProductDataValidator from "src/utils/ProductDataValidator";
import ApiUtil from "src/utils/ApiUtil";
import MetricsUtil from "src/utils/MetricsUtil";

export function* getSelectedProductData(action: SelectedProductQueryStartAction) {
    try {
        let response: SelectedProductResponse = {
            countryCode: action.countryCode,
            selectedProduct: action.selectedProduct
        };

        let metricsUtil = MetricsUtil.getMetricsUtil();
        metricsUtil.publishString("searchedASIN", action.selectedProduct.asin);

        yield put(getSelectedProductQuerySuccessAction(response));

        let product = response.selectedProduct;
        let getFeesInAdvance = ProductDataValidator.isProductValid(product) && product.price;
        if (getFeesInAdvance) {
            // We use merchant's price for fee estimation if available
            let queryProduct: QueryProductInfo = {
                asin: product.asin,
                merchantSku: product.merchantSku,
                fnsku: product.fnsku,
                glProductGroupName: product.gl,
                tRexId: product.tRexId,
                specialDeliveryRequirement: product.specialDeliveryRequirement,
                packageLength: product.length + '',
                packageWidth: product.width + '',
                packageHeight: product.height + '',
                dimensionUnit: product.dimensionUnit!,
                packageWeight: product.weight + '',
                weightUnit: product.weightUnit!,
                afnPriceStr: product.price + '',// User can update them in program component
                mfnPriceStr: product.price + '',
                mfnShippingPriceStr: '0',//TODO:get shipping from MYI
                currency: product.currency ? product.currency : getCurrencyUnitConfig(response.countryCode),
                isNewDefined: false,
            };
            yield put(setSelectedProductUpdate(response.countryCode, queryProduct));
        }

        let additionalInfo
        try {
            let parameters: any = {countryCode: action.countryCode, asin: action.selectedProduct.asin};
            // @ts-ignore
            additionalInfo = yield call(ApiUtil.callApiWithTimeout, "getadditionalpronductinfo", parameters);
            //if no featured offer, result is {"succeed":true,"data":null}
            yield put(getAdditionalInfoQuerySuccessAction(additionalInfo));
        }catch (e) {
            //Swallow exception
        }
        if (!getFeesInAdvance && ProductDataValidator.isProductValid(product)) {
            let featuredOfferPrice: number = additionalInfo?.data?.price?.amount;
            let featuredOfferShipping: number = additionalInfo?.data?.shipping?.amount;
            let featuredOfferCurrency: string = additionalInfo?.data?.price?.currency;
            let queryProduct: QueryProductInfo = {
                asin: product.asin,
                merchantSku: product.merchantSku,
                fnsku: product.fnsku,
                glProductGroupName: product.gl,
                tRexId: product.tRexId,
                specialDeliveryRequirement: product.specialDeliveryRequirement,
                packageLength: product.length + '',
                packageWidth: product.width + '',
                packageHeight: product.height + '',
                dimensionUnit: product.dimensionUnit!,
                packageWeight: product.weight + '',
                weightUnit: product.weightUnit!,
                afnPriceStr: featuredOfferPrice ? featuredOfferPrice + '' : '1',// User can update them in program component
                mfnPriceStr: featuredOfferPrice ? featuredOfferPrice + '' : '1',
                mfnShippingPriceStr: featuredOfferShipping ? featuredOfferShipping + '' : '0',
                currency: featuredOfferCurrency ? featuredOfferCurrency : getCurrencyUnitConfig(response.countryCode),
                isNewDefined: false,
            };
            yield put(setSelectedProductUpdate(response.countryCode, queryProduct));
        }

    } catch (error) {
        yield put(getSelectedProductQueryFailedAction());
        return;
    }

}

export default function* selectedProductData() {
    yield takeLatest(SELECTED_PRODUCT_QUERY_START, getSelectedProductData);
}